import { render, staticRenderFns } from "./VideoCarouselCard.vue?vue&type=template&id=1522aa81&scoped=true&"
import script from "./VideoCarouselCard.vue?vue&type=script&lang=js&"
export * from "./VideoCarouselCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoCarouselCard.vue?vue&type=style&index=0&id=1522aa81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522aa81",
  null
  
)

export default component.exports